import { useState } from 'react';
import { useReduxState } from 'hooks';
import { getCustomContentBasedOnLoginStrategy } from 'lib/common';
import { PageCustomContentContainer, PagePlain } from 'components/page';
import { LoginContainer } from 'components/login';

interface Props {
  next?: string | null;
}

const Login = ({ next }: Props) => {
  const { language, messages, serverConfig } = useReduxState();

  const [isStrategyLocal, setIsStrategyLocal] = useState(false);

  const handleActiveStrategyChange = (type: string) => {
    if (type === 'local' && !isStrategyLocal) setIsStrategyLocal(true);
    else if (type !== 'local' && isStrategyLocal) setIsStrategyLocal(false);
  };

  const { customContent, customContentBeside } =
    getCustomContentBasedOnLoginStrategy({
      isStrategyLocal,
      language,
      serverConfig
    });

  const availableAdditionalStrategies = serverConfig.authStrategies.filter(
    (strategy) => !strategy.hideFromLogin
  );

  const useLocalLogin = serverConfig.authEnableLocalLogin;

  const title =
    serverConfig.loginTitleLocales?.[language] ||
    serverConfig.loginTitle ||
    messages.authSignIn;

  return (
    <PagePlain
      padding={0}
      title={title}
      width={customContentBeside && customContent ? 'wide' : 'narrow'}
    >
      <div className="login">
        <PageCustomContentContainer
          customContent={customContent}
          customContentBeside={customContentBeside}
        >
          <LoginContainer
            availableAdditionalStrategies={availableAdditionalStrategies}
            handleActiveStrategyChange={handleActiveStrategyChange}
            initialActiveStrategy={
              useLocalLogin &&
              availableAdditionalStrategies.length === 0 &&
              (!serverConfig.enableRegistration ||
                !serverConfig.loginPageRegisterLinkAsButton)
                ? 'local'
                : null
            }
            next={next}
            registrationLinkEnabled={
              useLocalLogin && serverConfig.enableRegistration
            }
            useGuestHomeLogin={serverConfig.accountGuestEnableHomePage}
            useLocalLogin={useLocalLogin}
          />
        </PageCustomContentContainer>
      </div>
    </PagePlain>
  );
};

export default Login;
